<template>
	<b-modal id="modal-about" title="About UnderlineMe">
		<span class="close" @click="$bvModal.hide('modal-about')">
			<x-icon size="1.25x" class="custom-class"></x-icon>
		</span>
		<div class="">
			<h3>UnderlineMe v{{ version }}</h3>
			<p>
				UnderlineMe was developed in late July, 2020 as a simple annotation
				tool. Over time, we have added heaps of updates.
			</p>
		</div>
		<div v-if="updates">
			<div
				class="update-item"
				v-for="(update, index) in updates"
				v-if="update.public"
				:key="index"
			>
				<article>
					{{ update.notes }}
				</article>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons';
export default {
	components: {
		XIcon,
		CheckIcon,
	},
	data: function () {
		var obj = {
			lock: false,
			bucket: {
				title: '',
				color: 2,
			},
		};
		return obj;
	},
	computed: {
		version: function () {
			return this.$store.getters['version'];
		},
		updates: function () {
			return this.$store.getters['ui/updates'];
		},
	},
	methods: {},
	mounted: function () {},
};
</script>

<style lang="scss">
#modal-about___BV_modal_outer_ {
	.modal-dialog {
		max-width: 800px;
	}
	.update-item {
		margin-top: 10px;
	}
	strong {
		display: block;
		margin-bottom: var(--margin);
	}
	article {
		font-size: 14px;
		line-height: 1.4;
		white-space: break-spaces;
		word-break: break-word;
	}
}
</style>
